import type { Period } from 'types/global.types';

const getPeriodSlug = (tax?: { period: Period }): string => {
  const { year, quarter, month } = tax?.period || {};
  if (month) {
    return `${year}-${month}`;
  } else if (quarter) {
    return `${year}-4${quarter}`;
  } else {
    return `${year}`;
  }
};

export default getPeriodSlug;
